module.exports = __webpack_public_path__ + "static/media/palavras.042ebdd0.png";